import { render } from "./AboutScreenElements.vue?vue&type=template&id=3d130692&scoped=true"
import script from "./AboutScreenElements.vue?vue&type=script&lang=js"
export * from "./AboutScreenElements.vue?vue&type=script&lang=js"

import "./AboutScreenElements.vue?vue&type=style&index=0&id=3d130692&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d130692"]])

export default __exports__